import { render, staticRenderFns } from "./TemplatePreviewModal.vue?vue&type=template&id=90f0bece"
import script from "./TemplatePreviewModal.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90f0bece')) {
      api.createRecord('90f0bece', component.options)
    } else {
      api.reload('90f0bece', component.options)
    }
    module.hot.accept("./TemplatePreviewModal.vue?vue&type=template&id=90f0bece", function () {
      api.rerender('90f0bece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template-preview-modal/TemplatePreviewModal.vue"
export default component.exports